export const getCurrency = (domain) => {
    if(!domain) return "$"
    const filteredDomain = domain.replace("www.", "");
    const domainMapping = {
        'amazon.com': "$",
        'amazon.co.uk': "£",
        'amazon.de': "€",
        'amazon.fr': "€",
        'amazon.ca': "C$",
        'amazon.it': "€",
        'amazon.es': "€",
    };
    return domainMapping[filteredDomain] || "$";
};

export const formatHistoryDate = (value) => {
    try {
      const d = new Date(value);
      if (isNaN(d.getTime())) return '';
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const day = d.getDate();
      const month = months[d.getMonth()];
      const year = d.getFullYear();
      let hours = d.getHours();
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      if (hours === 0) hours = 12;
      const hoursStr = hours.toString().padStart(2, '0');
      return `${day} ${month} ${year}, ${hoursStr}:${minutes} ${ampm}`;
    } catch {
      return '';
    }
  };

  export const getAlertData = (alerts, basicInfo) => {
    if (!alerts) return { alertData: [], hasVisibleAlerts: false };
  
    const alertData = [
      {
        title: "M",
        color: alerts?.meltable ? "yellow" : "green",
        tooltipText: alerts?.meltable
          ? "The product is Meltable"
          : "The product is not Meltable",
        hidden: alerts?.meltable ? false : true,
      },
      {
        title: "AMZ",
        color: alerts?.amazonShareBuyBox ? "yellow" : "green",
        tooltipText: alerts?.amazonShareBuyBox
          ? "Amazon is present on this listing"
          : "Amazon does not hold the buy box",
        hidden: alerts?.amazonShareBuyBox ? false : true,
      },
      // {
      //   title: "LP",
      //   color: alerts?.low_price_FBA ? "yellow" : "green",
      //   tooltipText: alerts?.low_price_FBA
      //     ? "This product has low price FBA fee"
      //     : "This product does not meet the requirements for low price FBA fee",
      //   hidden: alerts?.low_price_FBA ? false : true,
      // },
      {
        title: "V",
        color: alerts?.variations ? "yellow" : "green",
        tooltipText: alerts?.variations
          ? "The product has some variations"
          : "The product do not variations",
        hidden: alerts?.variations ? false : true,
      },
      {
        title: "PL",
        color: alerts?.privateLabel ? "yellow" : "green",
        tooltipText: alerts?.privateLabel
          ? "This product is likely to be a private label"
          : "This product is unlikely to be a private label",
        hidden: alerts?.privateLabel ? false : true,
      },
      {
        title: "S",
        color: alerts?.size?.includes("oversize")
          ? "yellow"
          : "green",
        tooltipText: `size: ${alerts?.size}`,
        hidden: alerts?.size?.includes("oversize") ? false : true,
      },
      {
        title: "G",
        color: basicInfo?.brand === "Generic" ? "[#E74B4B]" : "green",
        tooltipText: `This product have Generic brand`,
        hidden: basicInfo?.brand === "Generic" ? false : true,
      },
      {
        title: "HZ",
        color: alerts?.hazmat ? "red" : "green",
        tooltipText: `This product is hazmat which means as a newer seller you will only be able to FBM this starting out`,
        hidden: alerts?.hazmat ? false : true,
      },
    ];
  
    const hasVisibleAlerts = alertData.some((alert) => !alert.hidden);
  
    return { alertData, hasVisibleAlerts };
  };

  export const formatNumber = (number) => {
    const num = Number(number);
    if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
    } else {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
};


const epochToLocalTime = (epochTime) => {
    const localDate = new Date(epochTime * 1000);
    return localDate.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };
  
export const convertEpochTimeToLocalTime = (epochTime) => {
    return epochToLocalTime(epochTime);
};


export const formatLength = (lengthInCm) => {
    if(lengthInCm < 100) {
        return lengthInCm + ' cm';
    }

    if (lengthInCm) {
        return (lengthInCm / 100).toFixed(2) + ' m';
    }

    return '--';
}

export const cmToInches = (cm) => {
    return (cm / 2.54).toFixed(2) + ' in';
}

export const formatWeight = (weightInGrams) => {
    const gramsToPounds = 0.00220462; // Conversion factor from grams to pounds
    const gramsToOunces = 0.03527396; // Conversion factor from grams to ounces

    if (weightInGrams < 453.592) { // 453.592 grams = 1 pound
        return (weightInGrams * gramsToOunces).toFixed(2) + ' oz';
    }
    if (weightInGrams) {
        return (weightInGrams * gramsToPounds).toFixed(2) + ' lb';
    }
    return '--';
}

export const mapDuration = (duration) => {
  if (duration === "1 Week") return "7";
  if (duration === "1 Month") return "30";
  if (duration === "3 Months") return "90";
  if (duration === "6 Months") return "180";
  if (duration === "1 Year") return "365";
  else return duration;
};

export const mapDataToLabels = (
  data,
  labels,
  selectedOption,
  valueProperty
) => {
  const dataMap = new Map();
  if (selectedOption === "1 Year" || selectedOption === "All") {
    data?.forEach((d) => {
      const localDate = convertEpochTimeToLocalTime(d.time);
      dataMap.set(localDate, d[valueProperty]);
    });

    return labels.map((label) => dataMap.get(label) || null);
  } else {
    let firstValue = null;

    data?.forEach((d) => {
      const value = parseFloat(d[valueProperty]);
      if (!isNaN(value) && firstValue === null) {
        firstValue = value;
      }
    });

    data?.forEach((d) => {
      const localDate = convertEpochTimeToLocalTime(d.time);
      const value = parseFloat(d[valueProperty]);
      if (!isNaN(value)) {
        dataMap.set(localDate, value);
      }
    });

    let foundFirstValue = false;
    return labels.map((label) => {
      if (dataMap.has(label)) {
        foundFirstValue = true;
        return dataMap.get(label);
      }
      return foundFirstValue ? null : firstValue;
    });
  }
};